const exampleJS = (() => {
    const init = () => {
        jQuery(() => {
            // if (!jQuery(".page-id-939").length) return;
            exampleJS();
        });
    };

    const exampleJS = () => {};

    return { init };
})();

jQuery(() => {
    exampleJS.init();
});
